const accessDocuments = {

    FOLDER_LIST: { name: 'Folder', path: '/folder-list' },
    ADD_FOLDER: { name: 'Add Folder', path: '/create-folder' },
    UPDATE_FOLDER: { name: 'Update Folder', path: '/edit-folder' },
    DELETE_FOLDER: { name: 'Delete Folder', path: '/delete-folder' },

    FILES_LIST: { name: 'Files', path: '/files-list' },
    ADD_FILES: { name: 'Add Files', path: '/create-files' },
    UPDATE_FILES: { name: 'Update Files', path: '/edit-files' },
    DELETE_FILES: { name: 'Delete Files', path: '/delete-files' },

    SUPERADMIN_DASHBOARD: { name: 'Super Admin Dashboard', path: '/superadmin-dashboard' },

    DOCUMENT: { name: 'Document', path: '/document' },
}

export default accessDocuments;